import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef, useCallback } from 'react';
import type { Duration } from 'date-fns';
import getUserHasSeen from '../services/getUserHasSeen';
interface UseUserHasSeenOptions {
  duration?: Duration;
  shouldPreventAutoSeen?: boolean;
}
const useUserHasSeen = (nameOfWhatToSee, userId, t0) => {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const initialOptions = useRef(options);
  const [hasSeen, setHasSeen] = useState(undefined);
  const localStorageKey = `has-seen-${nameOfWhatToSee}`;
  let t2;
  if ($[2] !== userId) {
    t2 = userId ? getUserHasSeen(userId) : undefined;
    $[2] = userId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const userHasSeenService = t2;
  let t3;
  if ($[4] !== nameOfWhatToSee || $[5] !== userHasSeenService) {
    t3 = () => {
      setHasSeen(true);
      return userHasSeenService?.set(nameOfWhatToSee, initialOptions.current.duration ? {
        duration: initialOptions.current.duration
      } : undefined);
    };
    $[4] = nameOfWhatToSee;
    $[5] = userHasSeenService;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const persistHasSeen = t3;
  let t4;
  if ($[7] !== nameOfWhatToSee || $[8] !== persistHasSeen || $[9] !== userHasSeenService) {
    t4 = () => {
      if (!userHasSeenService) {
        return;
      }
      userHasSeenService.get(nameOfWhatToSee).then(hasSeenStoredValue => {
        setHasSeen(Boolean(hasSeenStoredValue));
        if (!initialOptions.current.shouldPreventAutoSeen) {
          persistHasSeen();
        }
      });
    };
    $[7] = nameOfWhatToSee;
    $[8] = persistHasSeen;
    $[9] = userHasSeenService;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== localStorageKey || $[12] !== nameOfWhatToSee || $[13] !== persistHasSeen || $[14] !== userHasSeenService) {
    t5 = [userHasSeenService, localStorageKey, nameOfWhatToSee, persistHasSeen];
    $[11] = localStorageKey;
    $[12] = nameOfWhatToSee;
    $[13] = persistHasSeen;
    $[14] = userHasSeenService;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  useEffect(t4, t5);
  let t6;
  if ($[16] !== hasSeen || $[17] !== persistHasSeen) {
    t6 = {
      hasSeen,
      setSeen: persistHasSeen
    };
    $[16] = hasSeen;
    $[17] = persistHasSeen;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default useUserHasSeen;